import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v("Customer Insights: Mantenimiento de reportes"),
      ]),
      _c("actions-component", {
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function () {
              return [
                _vm.isInsishtsAdmin
                  ? _c(
                      VBtn,
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tab != 4,
                            expression: "tab != 4",
                          },
                        ],
                        staticClass: "ml-1 btn-inca-secondary",
                        attrs: { id: "btnAgregar", dense: "", outlined: "" },
                        on: {
                          click: function ($event) {
                            return _vm.$refs[_vm.getCurrentRef].onAdd()
                          },
                        },
                      },
                      [
                        _c(VIcon, { attrs: { small: "" } }, [
                          _vm._v(" icon-add"),
                        ]),
                        _vm._v(
                          " " + _vm._s(_vm.$t("botones.boton_crear")) + " "
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        VTabs,
        {
          attrs: { vertical: "" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(VTab, [_vm._v("Reportes")]),
          _vm.isInsishtsAdmin ? _c(VTab, [_vm._v("Regiones")]) : _vm._e(),
          _vm.isInsishtsAdmin
            ? _c(VTab, [_vm._v("Horas de actualización")])
            : _vm._e(),
          _vm.isInsishtsAdmin ? _c(VTab, [_vm._v("Secciones")]) : _vm._e(),
          _vm.isInsishtsAdmin ? _c(VTab, [_vm._v("usuarios")]) : _vm._e(),
          _c(
            VTabItem,
            [_c("somos1-reports-maintenance", { ref: _vm.prefixRef + "-0" })],
            1
          ),
          _c(
            VTabItem,
            [
              _c("regions-maintenance-component", {
                ref: _vm.prefixRef + "-1",
              }),
            ],
            1
          ),
          _c(
            VTabItem,
            [
              _c("update-hours-maintenance-component", {
                ref: _vm.prefixRef + "-2",
              }),
            ],
            1
          ),
          _c(
            VTabItem,
            [
              _c("sections-maintenance-component", {
                ref: _vm.prefixRef + "-3",
              }),
            ],
            1
          ),
          _c(
            VTabItem,
            [_c("users-maintenance-component", { ref: _vm.prefixRef + "-4" })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }